/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmission } from './PalAuthSubmission';
import {
    PalAuthSubmissionFromJSON,
    PalAuthSubmissionFromJSONTyped,
    PalAuthSubmissionToJSON,
    PalAuthSubmissionToJSONTyped,
} from './PalAuthSubmission';
import type { UploadPalReportToExternalEhrConfig } from './UploadPalReportToExternalEhrConfig';
import {
    UploadPalReportToExternalEhrConfigFromJSON,
    UploadPalReportToExternalEhrConfigFromJSONTyped,
    UploadPalReportToExternalEhrConfigToJSON,
    UploadPalReportToExternalEhrConfigToJSONTyped,
} from './UploadPalReportToExternalEhrConfig';

/**
 * 
 * @export
 * @interface UpdatePalAuthSubmissionRequest
 */
export interface UpdatePalAuthSubmissionRequest {
    /**
     * 
     */
    submission: PalAuthSubmission;
    /**
     * 
     */
    upload_pal_report_to_external_ehr_config?: UploadPalReportToExternalEhrConfig;
    /**
     * Next review date for creating first re-auth cycle (required when approving with concurrent_reviews enabled)
     */
    next_review_date?: string;
}

/**
 * Check if a given object implements the UpdatePalAuthSubmissionRequest interface.
 */
export function instanceOfUpdatePalAuthSubmissionRequest(value: object): value is UpdatePalAuthSubmissionRequest {
    if (!('submission' in value) || value['submission'] === undefined) return false;
    return true;
}

export function UpdatePalAuthSubmissionRequestFromJSON(json: any): UpdatePalAuthSubmissionRequest {
    return UpdatePalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function UpdatePalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalAuthSubmissionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'submission': PalAuthSubmissionFromJSON(json['submission']),
        'upload_pal_report_to_external_ehr_config': json['upload_pal_report_to_external_ehr_config'] == null ? undefined : UploadPalReportToExternalEhrConfigFromJSON(json['upload_pal_report_to_external_ehr_config']),
        'next_review_date': json['next_review_date'] == null ? undefined : json['next_review_date'],
    };
}

export function UpdatePalAuthSubmissionRequestToJSON(json: any): UpdatePalAuthSubmissionRequest {
    return UpdatePalAuthSubmissionRequestToJSONTyped(json, false);
}

export function UpdatePalAuthSubmissionRequestToJSONTyped(value?: UpdatePalAuthSubmissionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submission': PalAuthSubmissionToJSON(value['submission']),
        'upload_pal_report_to_external_ehr_config': UploadPalReportToExternalEhrConfigToJSON(value['upload_pal_report_to_external_ehr_config']),
        'next_review_date': value['next_review_date'],
    };
}

